// extracted by mini-css-extract-plugin
module.exports = {"mainCont":"style_mainCont__1g3y7","card":"style_card__1C8nu","title":"style_title__2CeHf","row":"style_row__3oWA1","circle":"style_circle__2fE_A"};